(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = document.querySelectorAll('[data-our-story-reveal]');
  if (!sections.length || !('IntersectionObserver' in window)) {
    sections.forEach(function (section) { section.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries, instance) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      instance.unobserve(entry.target);
    });
  }, { threshold: 0.12 });

  sections.forEach(function (section) { observer.observe(section); });

  document.querySelectorAll('[data-our-story-count]').forEach(function (counter) {
    var finalText = counter.textContent.trim();
    var match = finalText.replace(/,/g, '').match(/^(\d+)(.*)$/);
    if (!match) return;

    var target = Number(match[1]);
    var suffix = match[2];
    var started = false;
    var duration = 1200;

    function render(value) {
      counter.textContent = Math.round(value).toLocaleString('en-US') + suffix;
    }

    function countUp() {
      if (started) return;
      started = true;
      var startTime = performance.now();
      function frame(now) {
        var progress = Math.min((now - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        render(target * eased);
        if (progress < 1) window.requestAnimationFrame(frame);
      }
      window.requestAnimationFrame(frame);
    }

    var countObserver = new IntersectionObserver(function (entries, instance) {
      if (!entries[0].isIntersecting) return;
      countUp();
      instance.disconnect();
    }, { threshold: 0.35 });
    countObserver.observe(counter);
  });

  var dialog = document.querySelector('[data-our-story-build-dialog]');
  var dialogImage = dialog && dialog.querySelector('[data-our-story-build-dialog-image]');
  if (!dialog || !dialogImage) return;

  document.querySelectorAll('[data-our-story-build-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      dialogImage.src = button.getAttribute('data-image-src');
      dialogImage.alt = button.getAttribute('data-image-alt') || '';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
  });

  document.querySelector('[data-our-story-build-close]').addEventListener('click', function () {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
})();
